"use client";

import { motion } from "framer-motion";

export const div = motion.div;
export const h2 = motion.h2;
export const h1 = motion.h1;
export const p = motion.p;
export const section = motion.section;
